/**
 * Where a signed-in user should land, and where the nav's "Job Board" entry
 * points.
 *
 * The job board has two surfaces: `/job-board` is the read-only TV view, a
 * dense grid tuned for 10-foot legibility on a wall, and `/job-board/remote`
 * is the interactive one -- jump-to-job, browse by column, quick edit. A
 * person navigating the app always wants the remote, on a phone or a laptop
 * alike; the TV view is loaded by the wall display itself, which authenticates
 * with a board token and goes straight to the URL. So nothing in the app's
 * navigation needs to point at `/job-board`.
 *
 * start_screen stores a bare slug and pages/login/index.vue turns it into a
 * path. Users who already chose "Job Board" have "job-board" saved, so the
 * redirect has to happen here at resolve time -- renaming the option in
 * models/User.ts would leave every existing choice pointing at the TV view.
 */
export const JOB_BOARD_START_SCREEN = "job-board";

export const JOB_BOARD_REMOTE_PATH = "/job-board/remote";

/**
 * Turn a stored `start_screen` slug into the path to push after login.
 */
export function resolveStartScreenPath(startScreen) {
  if (!startScreen) return "/";

  if (startScreen === JOB_BOARD_START_SCREEN) return JOB_BOARD_REMOTE_PATH;

  return "/" + startScreen;
}
